module.exports = __webpack_public_path__ + "static/media/male_front_grey.bca4c256.png";